import * as React from 'react';

import Button from 'antd/lib/button';
import Dropdown from 'antd/lib/dropdown';

import defaultGearIcon from 'one-ui-svg/svg/gearwhite.svg';

import {
    Props,
} from 'one-ui';

import {
    BoxChart,
    BoxChartBody,
    BoxChartHeader,
} from 'one-ui-pie-chart';

import {
    IconSize,
    IconPosition,
} from 'one-ui-gear';

import {
    useCtx,
} from 'one-ui-provider';

export interface CardPieProps extends Props {
    title?: string;
    titleclass?: string;
    body: JSX.Element;
    gearIcon?: string,
    gearIconWidth?: string;
    gearIconHeight?: string;
    gearIconSize?: IconSize;
    gearActions?: JSX.Element;
    gearIconPosition?: IconPosition;
    classExtension?: string;
    gearclass?: string;
}

export const CardPieChart = ({
    body,
    title,
    gearActions,
    gearIconWidth = '12',
    gearIconHeight = '12',
    gearIconSize = 'small',
    gearIcon = defaultGearIcon,
    gearIconPosition = 'bottomRight',
    classExtension = "box",
    titleclass = "box__title box__title--gray",
    gearclass = "ant-btn--gear",
}: CardPieProps): JSX.Element => {
    const {
        resolver,
    } = useCtx();

    return (
        <BoxChart className={classExtension}>
            <BoxChartHeader title={title} titleclass={titleclass}>
                {gearActions && (
                    <Dropdown overlay={gearActions} placement={gearIconPosition}>
                        <Button size={gearIconSize} className={gearclass}>
                            <img
                                src={resolver(gearIcon)}
                                width={gearIconWidth}
                                height={gearIconHeight}
                                draggable="false"
                            />
                        </Button>
                    </Dropdown>
                )}
            </BoxChartHeader>
            <BoxChartBody>
                {body}
            </BoxChartBody>
        </BoxChart>
    );
};
